var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"*Style-Guide","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"Style-Guide","transform":"translate(-418.000000, -5760.000000)","fill":"#FFFFFF"},React.createElement("g",{"id":"1/3","transform":"translate(255.000000, 5714.000000)"},React.createElement("g",{"id":"arrow","transform":"translate(163.000000, 46.500000)"},React.createElement("polygon",{"points":"0 2.25 2.25 0 12 9.75 2.25 19.5 0 17.25 7.5 9.75"}))))));
}

ChevronRight.defaultProps = {"width":"12px","height":"20px","viewBox":"0 0 12 20","version":"1.1"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
